import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=76991384&scoped=true"
import script from "./product_detail.vue?vue&type=script&lang=js"
export * from "./product_detail.vue?vue&type=script&lang=js"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=76991384&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76991384",
  null
  
)

export default component.exports